// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationAssignments/styles.css
// module id = 2122
// module chunks = 0